import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {OddsByWidgetFetchHandler} from "./odds-by-widget.fetch-handler";

export class OddsByWidgetHandlers extends HandlerList {

  static injectables = [
    OddsByWidgetFetchHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
      oddsByWidgetFetchHandler: OddsByWidgetFetchHandler,
      timingHandler: TimingHandler,
      populateDataHandler: PopulateDataHandler
  ) {
    super();
    [
      oddsByWidgetFetchHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
